import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
    SelectRoot,
    SelectTrigger,
    SelectContent,
    SelectItem
} from "../ui/select"
import { useState, useEffect } from "react";
import { getCars } from "../../api/cars.api";
import { createTicket } from "../../api/tickets.api";
import styles from "../Overlay/Overlay.module.css"
import FieldForm from "../FieldForm";
import Overlay from "../Overlay";
import ButtonForm from "../ButtonForm";
import LabelRequired from "../LabelRequired";
import HeaderForm from "../HeaderForm";

function FormTicket({ setIsOpen, setTickets }) {
    const [status, setStatus] = useState("Aberto");
    const [custo, setCusto] = useState("")
    const [oficina, setOficina] = useState("")
    const [dataPrevista, setDataPrevista] = useState("")
    const [descricao, setDescricao] = useState("")




    const [cars, setCars] = useState([])
    const [carId, setCarId] = useState("0")

    useEffect(() => {
        getCars()
            .then(res => setCars(res.data))
            .catch((error) => {
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            });
    }, []);

    const formatCurrency = (rawValue) => {

        let digits = rawValue.replace(/\D/g, "");


        if (!digits) return "";

        const amount = (Number(digits) / 100).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true
        });

        return amount;
    };

    const handleChange = (e) => {
        const rawValue = e.target.value;
        const formattedValue = formatCurrency(rawValue);
        setCusto(formattedValue);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        const valueForBackend = custo.replace(/,/g, '');

        const dataFormatada = `${dataPrevista}T17:00:00`

        const ticketData = {
            Custo: valueForBackend,
            DataPrevisao: dataFormatada,
            Oficina: oficina,
            CarId: +carId === 0 ? null : +carId,
            Status: status,
            Descricao: descricao
        }

        await createTicket(ticketData)
            .then((response) => {
                setTickets(prevTickets => [...prevTickets, response.data])
                setIsOpen(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })
    }


    return (
        <Overlay>
            <form onSubmit={handleSubmit}>
                <HeaderForm 
                    title="Criar Ticket"
                    close={() => setIsOpen(false)}
                />
                <div className={styles.containerSelect}>
                    <div className={styles.select}>
                        <LabelRequired>Status</LabelRequired>
                        <SelectRoot value={status} onValueChange={setStatus}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value="Aberto">Aberto</SelectItem>
                                <SelectItem value="Pendente">Pendente</SelectItem>
                                <SelectItem value="Agendada">Agendada</SelectItem>
                                <SelectItem value="Em Andamento">Em Andamento</SelectItem>
                            </SelectContent>
                        </SelectRoot>
                    </div>
                    <div className={styles.select}>
                        <LabelRequired>Carro</LabelRequired>
                        <SelectRoot value={carId} onValueChange={setCarId}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value="0">Nenhum</SelectItem>
                                {Array.isArray(cars) ? cars.map((car, index) => {
                                    return <SelectItem value={car.id.toString()} key={index + 1}>{car.placa}</SelectItem>
                                }) : ""}
                            </SelectContent>
                        </SelectRoot>
                    </div>
                </div>
                <FieldForm
                    type="text"
                    placeholder="Zé Auto-Peças"
                    field="Oficina"
                    setThing={setOficina}
                />
                <div className={styles.customField}>
                    <label>Custo</label>
                    <input
                        className={styles.inputCusto}
                        type="text"
                        value={custo}
                        onChange={handleChange}
                        placeholder="0.00"
                    />
                </div>

                <FieldForm
                    type="date"
                    placeholder="01/02/2026"
                    field="Data Prevista"
                    setThing={setDataPrevista}
                />
                <div className={styles.textarea}>
                    <LabelRequired>Descrição</LabelRequired>
                    <textarea onChange={(e) => setDescricao(e.target.value)} placeholder="Descreva o problema..."></textarea>
                </div>

                <ButtonForm>Criar Ticket</ButtonForm>
            </form >
        </Overlay>
    )
}

export default FormTicket